import { render, staticRenderFns } from "./FormRatingVariants.vue?vue&type=template&id=0cbca781&"
import script from "./FormRatingVariants.vue?vue&type=script&lang=js&"
export * from "./FormRatingVariants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports